import api, { ApiResponse } from './api'

export interface CopilotMessage {
  role: 'user'
  content: string
}

export interface CopilotCitation {
  title: string
  url: string
  section?: string
}

export interface CopilotChatResponse {
  answer: string
  citations: CopilotCitation[]
}

export interface CopilotConfigResponse {
  enabled: boolean
}

export function getCopilotConfig(): Promise<ApiResponse<CopilotConfigResponse>> {
  return api.get('/v1/merchant/copilot/config')
}

export function sendCopilotMessage(
  messages: CopilotMessage[],
  language: 'en' | 'zh' | 'zh-Hant' = 'en'
): Promise<ApiResponse<CopilotChatResponse>> {
  return api.post('/v1/merchant/copilot/chat', { messages, language })
}
